import React from 'react';

interface GameCenter3DIconProps {
  size?: number;
  color?: string;
}

export const GameCenter3DIcon = ({ size = 48, color = '#F59E0B' }: GameCenter3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 40);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="16" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Controller body */}
      <path d="M8 28 C8 22 16 18 32 18 C48 18 56 22 56 28 L56 40 C56 46 48 50 32 50 C16 50 8 46 8 40 Z" fill={color} />
      {/* 3D right side */}
      <path d="M48 18 C54 20 56 22 56 28 L56 40 C56 46 54 48 48 50 L52 48 C56 46 58 44 58 40 L58 28 C58 22 56 20 52 18 Z" fill={darkerColor} />
      {/* Top highlight */}
      <path d="M8 28 C8 22 16 18 32 18 C48 18 56 22 56 28" fill={lighterColor} opacity="0.2" />
      {/* D-pad */}
      <rect x="17" y="30" width="3" height="10" rx="1" fill={darkerColor} />
      <rect x="14" y="33" width="9" height="3" rx="1" fill={darkerColor} />
      {/* Buttons */}
      <circle cx="44" cy="30" r="2.5" fill={darkerColor} />
      <circle cx="49" cy="34" r="2.5" fill={darkerColor} />
      <circle cx="44" cy="38" r="2.5" fill={darkerColor} />
      <circle cx="39" cy="34" r="2.5" fill={darkerColor} />
      {/* Grips */}
      <path d="M8 40 L6 50 C6 54 10 56 12 54 L14 46" fill={color} />
      <path d="M56 40 L58 50 C58 54 54 56 52 54 L50 46" fill={color} />
      <path d="M56 40 L58 50 C58 54 56 55 56 54 L54 46" fill={darkerColor} />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
